import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import { Modal } from '@adc/ui-core'
import classNames from 'classnames/bind'
import { gtmAuthModalOpen } from '../../shared/services/tracking'
import AuthToggle from './components' // this is really AuthToggleStepForm
import { USER_KINDS } from './constants'
import cls from './styles.scss'
const cx = classNames.bind(cls)

class AuthToggleModal extends PureComponent {
  static propTypes = {
    elmId: PropTypes.string,
    modal: PropTypes.object,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    featureFlags: PropTypes.object.isRequired,
    initialActive: PropTypes.string.isRequired,
    userKind: PropTypes.oneOf(Object.values(USER_KINDS)),
    signUpInitialValues: PropTypes.object,
    experiments: PropTypes.object,
  }

  static defaultProps = {
    elmId: 'auth_toggle',
    onClose: _.noop,
    isOpen: false,
    userKind: USER_KINDS.CONSUMER,
    signUpInitialValues: {},
  }

  componentDidMount() {
    const { initialActive } = this.props
    gtmAuthModalOpen({
      modalTab: initialActive,
    })
  }

  render() {
    const { elmId, modal, isOpen, onClose, ...rest } = this.props

    return (
      <Modal
        closeOnDimmerClick={false}
        mobileTitleSkin='light'
        elmId={`${elmId}_modal`}
        className={cx('root')}
        onClose={onClose}
        closeIcon={false}
        {...modal}
        open={isOpen}
      >
        <Modal.Content>
          <AuthToggle
            cls={{ root: cx('auth-modal-content') }}
            elmId={elmId}
            onClose={onClose}
            {...rest}
          />
        </Modal.Content>
      </Modal>
    )
  }
}

AuthToggleModal.USER_KINDS = USER_KINDS

export default AuthToggleModal
